import BaseService from './base.service'

export default class EmailService extends BaseService {
    send(emailData, fnSuccess, fnError) {
        return this.getApi().post(`/email/send`, emailData)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al enviar el correo')));
    }
}